<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('xgdlmm.title')}}</div>
        </div>
        <div class="cotainer">
            <div class="tips">{{$t('xgdlmm.zh')}}</div>
            <div class="input-box"><input class="input" type="text" v-model="account" :placeholder="$t('xgdlmm.zhts')"></div>
            <div class="tips">{{$t('xgdlmm.yzm')}}</div>
            <div class="input-box" v-if="lang == 'ar'"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"><input class="input" type="text" v-model="code" :placeholder="$t('xgdlmm.yzmts')"></div>
            <div class="input-box" v-else><input class="input" type="text" v-model="code" :placeholder="$t('xgdlmm.yzmts')"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"></div>
            <div class="tips">{{$t('xgdlmm.mm')}}</div>
            <div class="input-box">
              <input class="input" type="password" v-model="password" ref="input1" :placeholder="$t('xgdlmm.mmts')">
              <template v-if="isPwd1">
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass1" />
             </template>
             <template v-else>
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass1" />
             </template>
            </div>
            <div class="tips">{{$t('xgdlmm.qrmm')}}</div>
            <div class="input-box">
              <input class="input" type="password" v-model="password_again" ref="input2" :placeholder="$t('xgdlmm.mmts')">
              <template v-if="isPwd2">
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass2" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass2" />
              </template>
            </div>
            <div class="link-tips" @click="link">{{$t('mbwt.mbwt')}}</div>
            <button class="btn-login btn-bg" @click="sure">{{$t('xgdlmm.qr')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modifyPwd',
    data () {
        return {
          theme: false,
          account: '',
          code: '',
          password: '',
          password_again: '',
          countdown: 300,
          timer: null,
          isPwd1: true,
          isPwd2: true,
          count: 1,
          lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      shpass1() {
        if(this.isPwd1){
          this.isPwd1 = false;
          this.$refs.input1.type = "text";
        }else{
          this.isPwd1 = true;
          this.$refs.input1.type = "password";
        }
      },
      shpass2() {
        if(this.isPwd2){
          this.isPwd2 = false;
          this.$refs.input2.type = "text";
        }else{
          this.isPwd2 = true;
          this.$refs.input2.type = "password";
        }
      },
       goBack(){
           this.$router.push('/securityCenter')
       },
       link(){
           this.$router.push('/securityModPwd')
       },
       //获取手机邮箱验证码
       getCode(){
           let params = {
               account: this.account,
               type: 'forgetpwd',
               token: 1
           }
           if(this.account == '' || this.account == null){
               this.$toast.center(this.$t('xgdlmm.zhts'));
               return;
           }
           if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
           this.$ajax.get('/web/getCode',{params}).then((res) => {
                let resData = res.data;
                if(resData.code == 1){
                    this.$toast.center(resData.message);
                    this.count = 1;
                    return;
                }else{
                  this.count = 1;
                  this.settime()
                }

            }).catch(function(err){
                console.log(err)
            })
       },
       settime(){
           let generate_code = $("#fbtain");
           if (this.countdown == 0) {
                generate_code.attr("disabled", false);
                generate_code.val(this.$t('xgdlmm.hqyzm'));
                generate_code.css('color', '#5890bd');
                this.countdown = 300;
                return false;
            } else {
                generate_code.attr("disabled", true);
                generate_code.css('color', '#b6bfc4');
                generate_code.val(this.countdown + ' s');
                this.countdown--;
            }
            this.timer = setTimeout(() => {
                this.settime();
            }, 1000);
       },
       sure(){
           var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
            var params = {
                account : this.account,
                code : this.code,
                password : this.password,
                password_again : this.password_again,
                token: 1
            }
            if(params.account == '' || params.account == null){
                this.$toast.center(this.$t('xgdlmm.zhts'));
                return false;
            }
            if(params.code == '' || params.code == null){
                this.$toast.center(this.$t('xgdlmm.yzmts'));
                return false;
            }
            if(params.password == '' || params.password == null){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }else if(!reg.test(params.password)){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }
            if(params.password != params.password_again){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }
            this.$ajax.post('/web/updatePassword',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    setTimeout(() => {
                        this.$router.push('/securityCenter')
                    }, 1000)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       }
    },
    beforeDestroy(){
       clearTimeout(this.timer);
       this.timer = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 2.4rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .tips{
        padding: .54rem 0 .26rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem 0;
        border-bottom: .01rem solid #ececec;
    }
    .cotainer .input-pwd{
        margin-top: .76rem;
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .cotainer .input-box .code{
        width: 30%;
        color: #588bf8;
        font-size: .42rem;
        text-align: right;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .link-tips{
        margin-top: .45rem;
        color: #588bf8;
        font-size: .42rem;
        text-align: right;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: 1.7rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/modifyPwd.vue